import gql from 'graphql-tag';

export const CancellationRequest = gql`
    mutation cancellationRequest($request: CancellationRequest!) {
        cancellationRequest(request: $request) {
            refundEmailMessage
            refundFailedSummary {
                failedMessage
                requestCancellationMessage
                title
            }
            refundMessage
            refundTitle
            responseCode
            responseText
            responseTitle
        }
    }
`;
